import React from 'react';
import { StyleSheet } from 'react-native';

const BLOCKED_PROPS = new Set([
  'pointerEvents',
  'allowFontScaling',
  'selectable',
  'testID',
  'ellipsizeMode',
  'numberOfLines',
  'adjustsFontSizeToFit',
  'minimumFontScale',
  'suppressHighlighting',
  'onPress',
]);

function flattenStyle(style) {
  if (style == null) return undefined;
  let flattened = style;
  if (StyleSheet && typeof StyleSheet.flatten === 'function') {
    flattened = StyleSheet.flatten(style);
  } else if (Array.isArray(style)) {
    flattened = style.reduce((acc, s) => ({ ...acc, ...flattenStyle(s) }), {});
  }
  if (flattened && typeof flattened === 'object') {
    const safe = {};
    for (const [key, value] of Object.entries(flattened)) {
      if (/^\d+$/.test(key)) continue;
      safe[key] = value;
    }
    return safe;
  }
  return undefined;
}

function filterDomProps(props) {
  const domProps = {};
  for (const [key, value] of Object.entries(props)) {
    if (BLOCKED_PROPS.has(key)) continue;
    domProps[key] = value;
  }
  if (props.onPress && !domProps.onClick) {
    domProps.onClick = props.onPress;
  }
  return domProps;
}

export function createIcon() {
  return function Icon({
    name,
    size = 20,
    color = '#000',
    style,
    onPress,
    ...rest
  }) {
    const domProps = filterDomProps({ ...rest, onPress });
    const flatStyle = flattenStyle(style);

    return React.createElement(
      'span',
      {
        ...domProps,
        style: {
          fontSize: size,
          color,
          fontFamily: 'monospace',
          ...flatStyle,
        },
      },
      '⭐'
    );
  };
}
